// extracted by mini-css-extract-plugin
export default {"checkIcon":"YesNoIndicator_checkIcon__vf92o","crossIcon":"YesNoIndicator_crossIcon__h8VHn"};